// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://markazia-pos.azurewebsites.net/POSAPI/api/'
  // https://pos-markaziatest.azurewebsites.net/POSAPI/api/Branches/GetBranches?sort=1

  // apiUrl: 'https://pos-markaziatest.azurewebsites.net/POSAPI/api/'

  // apiUrl: 'https://pos-markaziatest.azurewebsites.net/POSAPI/api/',
  // apiUrl2: 'https://pos-markaziatest.azurewebsites.net/POSAPI/'

  // apiUrl: 'https://markaziaposdev.azurewebsites.net/POSAPI/api/',
  // apiUrl2: 'https://markaziaposdev.azurewebsites.net/POSAPI/',
  serverName:'https://dxdevmaster.markaziaapis.com/',
  apiUrl: 'https://dxdevservicelayer.markaziaapis.com/api/',
  apiUrl2: 'https://dxdevmaster.markaziaapis.com/'


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
